import frasekonsulent from "../../assets/people/frasekonsulent.jpg";

export default function BlivFrasekonsulent() {
  return (
    <div className="container mx-auto">
      <div className="pt-24 md:pt-32 mb-6 md:mb-20 md:mb-48 flex mx-auto border-t doctio-grey-border flex-col md:flex-row items-center">
        <div className="pr-0 md:flex-[0_0_50%] mx-auto md:pr-20 mr-auto">
          <img
            src={frasekonsulent}
            alt="Blive frasekonsulent - Doctio"
            className="rounded-2xl picture-shadow max-w-full"
          />
        </div>

        <div className="md:px-[15px] md:w-1/2 mx-auto mt-16 md:mt-0">
          <span className="tracking-[1px] mb-2 leading-[1.2]  text-dbase font-medium">
            BLIV EN DEL AF DOCTIO
          </span>
          <h3 className="text-dxl md:text-[2.5rem] mb-8 font-bold text-doctio-green">
            Bliv frasekonsulent og hjælp dine kollegaer
          </h3>
          <p className=" font-medium">
            Som frasekonsulent hos Doctio arbejder du, som det passer dig og når
            det passer dig. Er du fagligt dygtig, har interesse inden for et
            specielt speciale, og ønsker du at skrive nye fraser, hører vi gerne
            fra dig. Bliv del af et dedikeret og dygtigt hold, der brænder for
            at optimere arbejdsgangen for sundhedspersonale.
          </p>
          <p className=" font-medium">
            Er du speciallæge og har interesse i at speciallægevalidere allerede
            skrevne fraser, eller ligger du inde med stort bibliotek af
            specialespecifikke fraser, som du ønsker at dele/sælge, hører vi
            også gerne fra dig.
          </p>

          <p className=" font-medium">
            Klik på knappen og få mere information.
          </p>
          <a
            href="/kontakt-konsulent"
            className="text-white mx-auto md:mx-0 mt-12 button-shadow transition-colors duration-300  ease-in-out font-bold w-80 block rounded-full hover:bg-white hover:text-doctio-green  bg-doctio-green focus:outline-none px-4 py-2 text-center"
          >
            Bliv frasekonsulent
          </a>
        </div>
      </div>
    </div>
  );
}
